import { CARD_TYPE } from './CardType';

export const REGEX_CARD_TYPE = {
  [CARD_TYPE.AMEX]: /^3[47][0-9]{5,}$/,
  [CARD_TYPE.DINERS]: /^3(?:0[0-5]|[68][0-9])[0-9]{4,}$/,
  [CARD_TYPE.DISCOVER]: /^6(?:011|5[0-9]{2})[0-9]{3,}$/,
  [CARD_TYPE.JCB]: /^(?:2131|1800|35[0-9]{3})[0-9]{3,}$/,
  [CARD_TYPE.MASTER]: /^5[1-5][0-9]{5,}|222[1-9][0-9]{3,}|22[3-9][0-9]{4,}|2[3-6][0-9]{5,}|27[01][0-9]{4,}|2720[0-9]{3,}$/,
  [CARD_TYPE.VISA]: /^4[0-9]{6,}$/
};
